import React from "react";
import { Link, useLocation } from "react-router-dom";

const NavLinkItem = ({ children, to, href, target, active = false }) => {
  const className = `nav-link${active ? " active" : ""}`;

  if (to) {
    return (
      <li className="nav-item">
        <Link
          className={className}
          to={to}
          target={target}
          aria-current={active ? "page" : undefined}
        >
          {children}
        </Link>
      </li>
    );
  }

  return (
    <li className="nav-item">
      <a
        className={className}
        href={href}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
      >
        {children}
      </a>
    </li>
  );
};

const NavbarItem = () => {
  const { pathname } = useLocation();
  const isActionPage = pathname === "/action" || pathname.startsWith("/action/");

  return (
    <ul className="navbar-nav me-auto mb-lg-2 mb-lg-0">
      <NavLinkItem to="/" active={pathname === "/"}>
        HOME
      </NavLinkItem>
      <NavLinkItem to="/about" target="_blank" active={pathname === "/about"}>
        ABOUT
      </NavLinkItem>
      <NavLinkItem to="/action" target="_blank" active={isActionPage}>
        ACTION
      </NavLinkItem>
      <NavLinkItem
        href="https://beachcollectivellc.myshopify.com"
        target="_blank"
      >
        SHOP
      </NavLinkItem>
      <NavLinkItem to="/pay" target="_blank" active={pathname === "/pay"}>
        PAY
      </NavLinkItem>
      <NavLinkItem
        href="https://dexscreener.com/bsc/0x62b30616ae8743fdbb5f0fa6b6224785e38a7436"
        target="_blank"
      >
        TOKEN
      </NavLinkItem>
      <NavLinkItem
        href="https://cleanup-leaderboard.beachcollective.workers.dev"
        target="_blank"
      >
        REWARDS
      </NavLinkItem>
    </ul>
  );
};

export default NavbarItem;
